import { List } from 'immutable'
import { compose, equals, identity } from 'ramda'
import {
  setIn,
  updateIn,
  removeIn,
  push,
  filterNot,
  removeAllIn,
  getEq,
} from 'utils/immutable'
import * as actions from 'actions/feature/functions'
import { initialFunction } from 'reducers/feature'

export default {
  [actions.SET_FUNCTION_FIELD]: updateFunctionField,
  [actions.ADD_FUNCTION]: addFunction,
  [actions.DELETE_FUNCTION]: deleteFunction,
}

function updateFunctionField(state, { functionUri, paramName, value }) {
  const pathToField = [...pathToFunctions, functionUri, paramName]
  return setIn(pathToField, value)(state)
}

function addFunction(state, { payload }) {
  const { featureId, tmpId, description } = payload

  const newFunction = {
    ...initialFunction,
    uri: tmpId,
    id: tmpId,
    outputMap: tmpId,
    description,
  }

  const addNewFunction = setIn([...pathToFunctions, tmpId], newFunction)

  const appendToFeatureFunctions = updateIn(
    ['currentFeature', 'feature', featureId, 'functions'],
    push(tmpId)
  )

  const addToOutputMap = setIn(['currentFeature', 'outputMaps', tmpId], {
    fnId: tmpId,
    outputs: [],
    outputQuery: null,
  })

  return compose(
    addToOutputMap,
    addNewFunction,
    appendToFeatureFunctions
  )(state)
}

function deleteFunction(state, { payload }) {
  const { functionId, featureId } = payload

  const outputQueryUri = state.getIn([
    'currentFeature',
    'outputMaps',
    functionId,
    'outputQuery',
  ])
  const isSingleCondition = state.hasIn([
    'currentFeature',
    'conditions',
    outputQueryUri,
  ])

  const outputIds = getFunctionOutputIds(state, functionId)

  // find scalingQueries to remove
  const scalingQueryUris = outputIds.reduce((acc, id) => {
    const scalingQueryUri = state.getIn([
      'currentFeature',
      'outputs',
      id,
      'scalingQuery',
    ])

    if (!scalingQueryUri) return acc

    return acc.push(scalingQueryUri)
  }, List())

  // if there is a single condition, remove it
  const removeSingleCondition = isSingleCondition
    ? removeIn(['currentFeature', 'conditions', outputQueryUri])
    : identity

  // remove single condition from queries list
  const removeConditionFromFeatureList = isSingleCondition
    ? updateIn(
        ['currentFeature', 'feature', featureId, 'queries'],
        filterNot(getEq('id', outputQueryUri))
      )
    : identity

  // find and remove all outputs
  const removeOutputs = removeAllIn(outputIds, ['currentFeature', 'outputs'])
  const removeScalingQueries = removeAllIn(scalingQueryUris, [
    'currentFeature',
    'scalingQueries',
  ])

  // remove function from the output map
  const removeFromOutputMap = removeIn([
    'currentFeature',
    'outputMaps',
    functionId,
  ])

  // remove the function
  const removeInFunctions = removeIn([...pathToFunctions, functionId])

  // remove reference to function at the feature level
  const removeInFeatureFunctions = updateIn(
    ['currentFeature', 'feature', featureId, 'functions'],
    filterNot(equals(functionId))
  )

  return compose(
    removeScalingQueries,
    removeSingleCondition,
    removeConditionFromFeatureList,
    removeFromOutputMap,
    removeInFunctions,
    removeInFeatureFunctions,
    removeOutputs
  )(state)
}

// //////////////////////////////////////
// HELPERS

const pathToFunctions = ['currentFeature', 'functions']
const getFunctionOutputIds = (state, id) =>
  state.getIn(['currentFeature', 'outputMaps', id, 'outputs'])
